import { render } from "./ModifyUnderscore.vue?vue&type=template&id=4aa1139e"
import script from "./ModifyUnderscore.vue?vue&type=script&lang=js"
export * from "./ModifyUnderscore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Questionnaire/Question/ModifyUnderscore.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4aa1139e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4aa1139e', __exports__)) {
    api.reload('4aa1139e', __exports__)
  }
  
  module.hot.accept("./ModifyUnderscore.vue?vue&type=template&id=4aa1139e", () => {
    api.rerender('4aa1139e', render)
  })

}


export default __exports__